import { useEffect, useState } from "react";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";


export default function CustomerBilling(props) {

    const { controller = "", callback = () => { }, route = "", value = "" } = props;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        loadNames(value);
    }, [value]);

    const loadNames = (value) => {
        pubCall("customer.searchName", { name: value, limit: 40 }, (_s, _r) => {
            if (_s) {
                setData(_r.rows_next);
            } else {
                showError(_r);
            }
        });
    }

    const columns = [
        { key: "name", align: "left", width: 200},
        { key: "ship_to", align: "left", width: 100},
    ]

    return (
        <>
            <VirtualTable
                controller={controller}
                row_key={"ship_to"}
                columns={columns}
                route={route}
                current={selected}
                data={data}
                width={300}
                height={200}
            />
        </>
    )
}